import { render, staticRenderFns } from "./lawyerNavigation.vue?vue&type=template&id=8a3c62d2&scoped=true"
import script from "./lawyerNavigation.vue?vue&type=script&lang=js"
export * from "./lawyerNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3c62d2",
  null
  
)

export default component.exports